export type CurrencyCode =
    | 'AED'
    | 'ARS'
    | 'AUD'
    | 'BGN'
    | 'BHD'
    | 'BRL'
    | 'BWP'
    | 'CAD'
    | 'CHF'
    | 'CNY'
    | 'CZK'
    | 'DKK'
    | 'EGP'
    | 'ETB'
    | 'EUR'
    | 'GBP'
    | 'GHS'
    | 'GMD'
    | 'HUF'
    | 'ILS'
    | 'INR'
    | 'JPY'
    | 'KES'
    | 'MAD'
    | 'MUR'
    | 'MWK'
    | 'MXN'
    | 'MYR'
    | 'NGN'
    | 'NOK'
    | 'NZD'
    | 'PEN'
    | 'PLN'
    | 'QAR'
    | 'RUB'
    | 'RWF'
    | 'SAR'
    | 'SEK'
    | 'SGD'
    | 'SLL'
    | 'THB'
    | 'TRY'
    | 'TZS'
    | 'UGX'
    | 'USD'
    | 'VEF'
    | 'VND'
    | 'XAF'
    | 'XOF'
    | 'ZAR'
    | 'ZMK'
    | 'ZMW';

function getCurrencySymbol(currencyCode: CurrencyCode) {
    const currencySymbols = {
        AED: 'د.إ',
        ARS: '$',
        AUD: 'A$',
        BGN: 'лв',
        BHD: '.د.ب',
        BRL: 'R$',
        BWP: 'P',
        CAD: 'C$',
        CHF: 'CHF',
        CNY: '¥',
        CZK: 'Kč',
        DKK: 'kr',
        EGP: 'E£',
        ETB: 'Br',
        EUR: '€',
        GBP: '£',
        GHS: 'GH₵',
        GMD: 'D',
        HUF: 'Ft',
        ILS: '₪',
        INR: '₹',
        JPY: '¥',
        KES: 'KSh',
        MAD: 'د.م.',
        MUR: '₨',
        MWK: 'MK',
        MXN: '$',
        MYR: 'RM',
        NGN: '₦',
        NOK: 'kr',
        NZD: 'NZ$',
        PEN: 'S/',
        PLN: 'zł',
        QAR: 'ر.ق',
        RUB: '₽',
        RWF: 'FRw',
        SAR: '﷼',
        SEK: 'kr',
        SGD: 'S$',
        SLL: 'Le',
        THB: '฿',
        TRY: '₺',
        TZS: 'TSh',
        UGX: 'USh',
        USD: '$',
        VEF: 'Bs.',
        VND: '₫',
        XAF: 'FCFA',
        XOF: 'CFA',
        ZAR: 'R',
        ZMK: 'ZK',
        ZMW: 'ZK',
    };

    return currencySymbols[currencyCode] || '₦';
}

export default getCurrencySymbol;
